<template>
  <div class="jimuyun">
    <el-card class="my_card2" shadow="never">
      <div class="top">
        <p>
          <span class="s1">积木云助手IP管理</span
          ><span class="s2"
            >我们提供积木云助手IP形象更换，企业可根据自身的品牌调性更换积木云AI助手表情IP</span
          >
        </p>
        <el-button type="primary" round>保存</el-button>
      </div>
      <ul class="ul1">
        <!-- 1 -->
        <li>
          <div class="ip">
            <img src="../../../assets/images/newIcon/ai_IP_icon.png" alt="" />
            <p>品牌IP</p>
          </div>
          <div class="func">
            <p>功能</p>
            <ul>
              <li>
                <img
                  style="
                    width: 16px;
                    height: 16px;
                    transform: translate(0px, 3px);
                  "
                  src="../../../assets/images/ticons/Slice 5.png"
                  alt=""
                /><span>功能使用提示</span>
              </li>
              <li>
                <img
                  style="
                    width: 16px;
                    height: 16px;
                    transform: translate(0px, 3px);
                  "
                  src="../../../assets/images/ticons/Slice 5.png"
                  alt=""
                /><span>数据提示</span>
              </li>
              <li>
                <img
                  style="
                    width: 16px;
                    height: 16px;
                    transform: translate(0px, 3px);
                  "
                  src="../../../assets/images/ticons/Slice 5.png"
                  alt=""
                /><span>会员事件分析</span>
              </li>
              <li>
                <img
                  style="
                    width: 16px;
                    height: 16px;
                    transform: translate(0px, 3px);
                  "
                  src="../../../assets/images/ticons/Slice 5.png"
                  alt=""
                /><span>营销事件分析</span>
              </li>
              <li>
                <img
                  style="
                    width: 16px;
                    height: 16px;
                    transform: translate(0px, 3px);
                  "
                  src="../../../assets/images/ticons/Slice 5.png"
                  alt=""
                /><span>关键行为洞察</span>
              </li>
            </ul>
          </div>
          <div class="tips">
            <img src="../../../assets/images/newIcon/ai_IP_icon.png" alt="" />
            <div>品牌ip将应用于积木云数字化中台的多项场景，快来更换吧～</div>
          </div>
          <el-button type="primary" round @click="dialogTableVisible = true"
            >更换IP</el-button
          >
        </li>
        <!-- 2 -->
        <li>
          <div class="ip">
            <img src="../../../assets/images/newIcon/ai_IP_icon.png" alt="" />
            <p>增长IP动作</p>
          </div>
          <div class="func">
            <p>功能</p>
            <ul>
              <li>
                <img
                  style="
                    width: 16px;
                    height: 16px;
                    transform: translate(0px, 3px);
                  "
                  src="../../../assets/images/ticons/Slice 5.png"
                  alt=""
                /><span>会员事件增长提示</span>
              </li>
              <li>
                <img
                  style="
                    width: 16px;
                    height: 16px;
                    transform: translate(0px, 3px);
                  "
                  src="../../../assets/images/ticons/Slice 5.png"
                  alt=""
                /><span>营销事件增长提示</span>
              </li>
              <li>
                <img
                  style="
                    width: 16px;
                    height: 16px;
                    transform: translate(0px, 3px);
                  "
                  src="../../../assets/images/ticons/Slice 5.png"
                  alt=""
                /><span>数字化增长提示</span>
              </li>
            </ul>
          </div>
          <div class="tips">
            <img src="../../../assets/images/newIcon/ai_IP_icon.png" alt="" />
            <div>
              增长ip将应用于企业数字化增长的场景，可上传企业ip的增长表情
            </div>
          </div>
          <el-button type="primary" round @click="dialogTableVisible = true"
            >更换IP</el-button
          >
        </li>
        <!-- 3 -->
        <li>
          <div class="ip">
            <img src="../../../assets/images/newIcon/ai_IP_icon.png" alt="" />
            <p>下滑IP动作</p>
          </div>
          <div class="func">
            <p>功能</p>
            <ul>
              <li>
                <img
                  style="
                    width: 16px;
                    height: 16px;
                    transform: translate(0px, 3px);
                  "
                  src="../../../assets/images/ticons/Slice 5.png"
                  alt=""
                /><span>会员事件下滑提示</span>
              </li>
              <li>
                <img
                  style="
                    width: 16px;
                    height: 16px;
                    transform: translate(0px, 3px);
                  "
                  src="../../../assets/images/ticons/Slice 5.png"
                  alt=""
                /><span>营销事件下滑提示</span>
              </li>
              <li>
                <img
                  style="
                    width: 16px;
                    height: 16px;
                    transform: translate(0px, 3px);
                  "
                  src="../../../assets/images/ticons/Slice 5.png"
                  alt=""
                /><span>企业数字化下滑提示</span>
              </li>
            </ul>
          </div>
          <div class="tips">
            <img src="../../../assets/images/newIcon/ai_IP_icon.png" alt="" />
            <div>
              下滑ip动作将应用于企业数字化下滑时的场景，可上传企业ip的下滑标签
            </div>
          </div>
          <el-button type="primary" round @click="dialogTableVisible = true"
            >更换IP</el-button
          >
        </li>
      </ul>
    </el-card>
    <!-- 弹框 -->
    <el-dialog title="上传IP形象" :visible.sync="dialogTableVisible">
      <p class="hint">建议尺寸：500*500</p>
      <div class="showInfo">
        <p>截取展示区域</p>
        <p>展示效果</p>
      </div>
      <div style="display: flex" class="avatar">
        <div class="avatar-left">
          <div v-show="!options.img">
            <el-upload
              ref="upload"
              action=""
              style="
                text-align: center;
                margin-bottom: 24px;
                width: 400px;
                height: 300px;
              "
              :on-change="uploads"
              accept="image/png, image/jpeg, image/jpg"
              :show-file-list="false"
              :auto-upload="false"
            >
             <div>
                <el-button
                slot="trigger"
                size="small"
                type="primary"
                ref="uploadBtn"
                >选择图片</el-button
              >
               <div style="margin-top:5px;">支持jpg、png格式的图片，大小不超过3M</div>
             </div>
            </el-upload>
           
          </div>
          <div v-show="options.img" class="avatar-left-crop">
            <vueCropper
              class="crop-box"
              ref="cropper"
              :img="options.img"
              :info="options.info"
              :outputSize="options.outputSize"
              :outputType="options.outputType"
              :canMove="options.canMove"
              :autoCrop="options.autoCrop"
              :autoCropWidth="options.autoCropWidth"
              :autoCropHeight="options.autoCropHeight"
              :fixedBox="options.fixedBox"
              :original="options.original"
              :infoTrue="options.infoTrue"
              :centerBox="options.centerBox"
              :canMoveBox="options.canMoveBox"
              :canScale="options.canScale"
              :fixed="options.fixed"
              :fixedNumber="options.fixedNumber"
              @realTime="realTime"
            >
            </vueCropper>
            <p class="avatar-left-p">
              鼠标滚轮缩放控制图片显示大小，鼠标拖拽调整显示位置
            </p>
          </div>
        </div>
        <div class="avatar-right">
          <div
            class="avatar-right-div"
            v-for="(item, index) in previewsDiv"
            :key="index"
            :style="item.style"
          >
            <img :src="previews.url" :style="previews.img" />
          </div>
          <div class="avatar-right-text">
            <el-button v-if="options.img" type="text" @click="uploadPreviews"
              >重新上传</el-button
            >
            <span v-else>预览</span>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogTableVisible = false" round>取 消</el-button>
        <el-button type="primary" @click="dialogTableVisible = false" round
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      //控制弹框
      dialogTableVisible: false,
      options: {
        img: "", //裁剪图片的地址
        outputSize: 1, //裁剪生成图片的质量(可选0.1 - 1)
        outputType: "jpeg", //裁剪生成图片的格式（jpeg || png || webp）
        info: true, //图片大小信息
        canScale: true, //图片是否允许滚轮缩放
        autoCrop: true, //是否默认生成截图框
        autoCropWidth: 230, //默认生成截图框宽度
        autoCropHeight: 150, //默认生成截图框高度
        fixed: true, //是否开启截图框宽高固定比例
        fixedNumber: [1.53, 1], //截图框的宽高比例
        full: false, //false按原比例裁切图片，不失真
        fixedBox: true, //固定截图框大小，不允许改变
        canMove: false, //上传图片是否可以移动
        canMoveBox: true, //截图框能否拖动
        original: false, //上传图片按照原始比例渲染
        centerBox: false, //截图框是否被限制在图片里面
        height: true, //是否按照设备的dpr 输出等比例图片
        infoTrue: true, //true为展示真实输出图片宽高，false展示看到的截图框宽高
        maxImgSize: 3000, //限制图片最大宽度和高度
        enlarge: 1, //图片根据截图框输出比例倍数
        mode: "230px 150px", //图片默认渲染方式
      },
      //实时预览图数据
      previews: {},
      //实时预览图样式
      previewsDiv: [
        //108px 预览样式
        {
          style: {
            width: "230px",
            height: "150px",
            margin: "50px auto",
          },
        },
      ],
    };
  },
  methods: {
    uploads(file) {
      const isIMAGE =
        file.raw.type === "image/jpeg" || file.raw.type === "image/png";
      const isLt3M = file.raw.size / 1024 / 1024 < 3;
      if (!isIMAGE) {
        this.$message({
          showClose: true,
          message: "请选择 jpg、png 格式的图片！",
          type: "error", //提示类型
        });
        return false;
      }
      if (!isLt3M) {
        this.$message({
          showClose: true,
          message: "上传图片大小不能超过 3MB",
          type: "error", //提示类型
        });
        return false;
      }
      let reader = new FileReader();
      reader.readAsDataURL(file.raw);
      reader.onload = (e) => {
        this.options.img = e.target.result; //base64
      };
    },
    //实时预览数据
    realTime(data) {
      this.previews = data;
    },
    //重新上传
    uploadPreviews() {
      this.$refs.uploadBtn.$el.click();
    },
    //获取截图信息
    getCrop() {
      // 获取截图的 base64 数据
      this.$refs.cropper.getCropData((data) => {
        console.log(data);
      });
      // 获取截图的 blob 数据
      this.$refs.cropper.getCropBlob((data) => {
        console.log(data);
      });
    },
    //关闭弹框
    closeDialog() {
      //调用父组件关闭弹框方法 closeAvatarEdits()
      this.$parent.closeAvatarEdits();
      //重置 data 数据。(Object.assign是对象深复制  this.$data是组件内的数据对象 this.$options.data()是原始的数据)
      Object.assign(this.$data, this.$options.data());
    },
  },
};
</script>

<style lang="less">
.jimuyun {
  .my_card2 {
    height: 650px;
    padding: 0 50px 0 0;
    .top {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .s1 {
        font-size: 16px;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #33393f;
      }
      .s2 {
        margin-left: 12px;
        font-size: 12px;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 400;
        color: #777777;
      }
      .el-button {
        font-size: 12px;
      }
      .el-button--mini,
      .el-button--mini.is-round {
        padding: 9px 15px;
      }
    }
    .ul1 {
      display: flex;
      justify-content: space-between;
      box-sizing: border-box;
      margin-top: 20px;
      padding-left: 36px;
      > li {
        box-sizing: border-box;
        padding-top: 29px;
        padding: 29px 23px 0 21px;
        width: 330px;
        height: 485px;
        background: rgba(50, 126, 255, 0.07853474467992783);
        //头像部分
        .ip {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          img {
            width: 73px;
            height: 68px;
          }
          p {
            font-size: 16px;
            font-family: PingFang SC-Medium, PingFang SC;
            font-weight: 500;
            color: #33393f;
          }
        }
        //功能文字部分
        .func {
          box-sizing: border-box;
          padding: 12px 10px;
          margin-top: 19px;
          width: 286px;
          height: 188px;
          background-color: #fff;
          // "功能"这个字
          p {
            font-size: 14px;
            font-family: PingFang SC-Medium, PingFang SC;
            font-weight: 500;
            color: #33393f;
          }
          // 下面5条信息
          ul {
            margin-top: 15px;
            li {
              margin-top: 10px;
              &:first-child {
                margin-top: 0;
              }
              span {
                margin-left: 5px;
                font-size: 12px;
                font-family: PingFang SC-Regular, PingFang SC;
                font-weight: 400;
                color: #33393f;
              }
            }
          }
        }
        //提示信息
        .tips {
          margin-top: 10px;
          display: flex;
          align-items: center;
          img {
            width: 40px;
            height: 37px;
          }
          div {
            box-sizing: border-box;
            padding: 5px 10px;
            flex: 1;
            height: 50px;
            display: flex;
            align-items: center;
            background-color: #fff;
            margin-left: 5px;
            background: url(~@/assets/images/ticons/Slice 17@2x.png) no-repeat;
            background-size: 100% 100%;
            // transform: rotate(180deg);
            font-size: 12px;
            font-family: PingFang SC-Regular, PingFang SC;
            font-weight: 400;
            color: #666666;
          }
        }
        //按钮
        .el-button {
          margin-top: 27px;
          margin-left: 47px;
          width: 197px;
          height: 50px;
          border-radius: 25px;
        }
      }
    }
  }
  .greColor {
    color: #63b011;
    font-size: 18px;
  }
  .hint {
    font-size: 14px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    padding-left: 20px;
  }
  .showInfo {
    display: flex;
    justify-content: flex-start;
    margin-top: 30px;
    font-size: 14px;
    font-family: PingFang SC-Medium, PingFang SC;
    font-weight: 500;
    color: #686868;
    padding-left: 20px;
    p {
      flex: 1;
      &:nth-child(1) {
        margin-right: 60px;
      }
    }
  }
  .avatar {
    display: flex;
    .vue-cropper{
      background-image:none ;
    }
    .avatar-left {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 400px;
      height: 300px;
      background-color: #f0f2f5;
      margin-right: 10px;
      border-radius: 4px;

      .avatar-left-crop {
        width: 400px;
        height: 300px;
        position: relative;

        .crop-box {
          width: 100%;
          height: 100%;
          border-radius: 4px;
          // overflow: hidden;
        }
      }

      .avatar-left-p {
        text-align: center;
        width: 100%;
        position: absolute;
        bottom: 20px;
        color: #ffffff;
        font-size: 14px;
      }
    }

    .avatar-right {
      width: 500px;
      height: 300px;
      background-color: #f0f2f5;
      border-radius: 4px;
      padding: 16px 0;
      box-sizing: border-box;

      .avatar-right-div {
        margin-top: 50px;
        border: 3px solid #ffffff;
        overflow: hidden;
      }

      .avatar-right-previews {
        width: 335px;
        height: 326px;
        overflow: hidden !important;
        margin: 150px auto;
      }

      .avatar-right-text {
        text-align: center;
        margin-top: 10px;
        font-size: 14px;

        /deep/ .el-button {
          padding: 0;
        }

        span {
          color: #666666;
        }
      }
    }
  }
}
</style>